<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="operate"
      :searchs="searchs"
      :form-fields="formFields"
      :permission="permission"
    />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'

export default {
  name: 'ReplaceImage',
  components: { CommonTable },
  data() {
    return {
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },
      ],
      permission: {
        add: 'replaceImage:add',
        update: 'replaceImage:update',
        delete: 'replaceImage:delete',
        deleteBatch: 'replaceImage:deleteBatch',
      },
      url: {
        get: '/replaceImage/listByCondition',
        add: '/replaceImage/add',
        update: '/replaceImage/update',
        delete: '/replaceImage/delete/',
        delete_batch: '/replaceImage/deleteBatch',
      },
      tableColumns: [
        {
          field: 'id',
          label: 'Id',
          show: true,
          width: '100',
        },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          width: '',
        },
        /*{
          field: 'countryId',
          label: '国家',
          selectUrl: '/country/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          width: '',
        },*/
        {
          field: 'url',
          label: '图片',
          detail: true,
          show: true,
          img: true,
          width: '',
        },
        {
          field: 'jumpUrl',
          label: '跳转地址',
          show: false,
          width: '',
        },
        {
          field: 'sortId',
          label: '排序字段',
          show: true,
          width: '',
        },
      ],
      operate: [
        {
          icon: 'el-icon-upload2',
          type: 'text',
          text: '上传图片',
          uploadImg: true,
          // url: 'https://img.imageoss.top/upload.php',
          url: this.reUrl + '/system/upload/oss/img',
          // 用于存储handle的row
          value: {},
          handle: (row) => {
            this.value = row
          },
          success: (res) => {
            console.log(res)
            if (res.code === 0) {
              const value = JSON.parse(JSON.stringify(this.value))
              value.img = res.data
              this.$axios.post({
                url: '/replaceImage/img/update',
                data: value,
                success: (data) => {
                  if (data.code === 0) {
                    this.$message.success('图片上传成功')
                    this.$set(this.value, 'img', value.img)
                  } else {
                    this.$message.error(data.msg ? data.msg : '图片上传失败')
                  }
                },
              })
            } else if (res.code === 102) {
              window.localStorage.removeItem('username')
              window.localStorage.removeItem('sessionId')
              window.parent.location.href = this.feUrl + '/login.html'
            }
          },
        },
      ],
      formFields: {
        addTitle: '添加轮播图片地址',
        updateTitle: '修改轮播图片地址',
        model: [
          {
            field: 'agentId',
            label: '代理',
            type: 'select',
            selectUrl: '/agent/getAll',
            selectData: [],
            placeholder: '请选择',
            rules: [
              {
                message: '请选择代理',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          },
        /*  {
            field: 'countryId',
            label: '国家ID',
            type: 'select',
            selectUrl: '/country/getAll',
            selectData: [],
            placeholder: '请选择',
            rules: [
              {
                message: '请选择国家ID',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          },*/
         /* {
            field: 'jumpUrl',
            label: '跳转地址',
            type: 'input',
            placeholder: '跳转地址',
            rules: [{ message: '请输入版本', trigger: 'blur', required: true }],
            add: true,
            update: true,
          },*/
          {
            field: 'sortId',
            label: '排序字段',
            type: 'input',
            placeholder: '排序字段',
            rules: [
              { message: '请输入版本号', trigger: 'blur', required: true },
            ],
            add: true,
            update: true,
          },
        ],
      },
    }
  },
}
</script>

<style scoped>
</style>
